






































































































import { Component, namespace, Prop, mixins } from 'nuxt-property-decorator'
import {
  mdiAccountOutline,
  mdiHeartOutline,
  mdiCartOutline,
  mdiChartBoxOutline,
} from '@mdi/js'

import {
  CART_PATH,
  COMPARE_PATH,
  FAVOURITES_PATH,
  ORDERS_PATH,
  PERSONAL_PATH,
} from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import MixinGeneral from '~/assets/mixins/general'
import { IUser } from '~/assets/interfaces/user'
import ComponentIcon from '~/components/icon/icon.vue'
import componentBadge from '~/components/badge/badge.vue'
import ComponentDropdown from '~/components/dropdown/dropdown.vue'
const auth = namespace('auth')
const cartStore = namespace('cart')
const favouritesStore = namespace('favourites')
const compareStore = namespace('compare')
const siteStore = namespace('site')

let timer = 0

@Component({
  components: {
    ComponentIcon,
    ComponentLoadingDots: () => import('~/components/loading/dots.vue'),
    componentBadge,
    ComponentAuth: () => import('~/components/auth/auth.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentDropdown,
  },
  filters: {
    filterUrl,
  },
})
export default class componentHeaderMenuUser extends mixins(MixinGeneral) {
  @Prop({ type: Boolean }) readonly white!: boolean
  @Prop({ type: String, default: 'secondary' }) readonly colorBadge!: string
  @auth.State('loggedIn') loggedIn!: boolean
  @auth.State('user') user!: IUser
  @cartStore.Getter('itemsQuantity') cartItemsQuantity!: number
  @favouritesStore.Getter('itemsQuantity') favouritesItemsQuantity!: number
  @compareStore.Getter('itemsQuantity') compareItemsQuantity!: number
  @siteStore.Getter('getOptionsCompare') private isCompareEnabled!: boolean

  private PERSONAL_PATH = PERSONAL_PATH
  private ORDERS_PATH = ORDERS_PATH
  private FAVOURITES_PATH = FAVOURITES_PATH
  private CART_PATH = CART_PATH
  private COMPARE_PATH = COMPARE_PATH

  private isComponentAuthLoaded = false
  private icons = {
    mdiAccountOutline,
    mdiHeartOutline,
    mdiCartOutline,
    mdiChartBoxOutline,
  }

  private isShowAuthPopup = false
  private ShowAuthPopup() {
    this.isShowAuthPopup = true
  }

  private isShowMenuDropdownUser = false

  private openDropdown() {
    clearTimeout(timer)
    this.isShowMenuDropdownUser = true
  }

  private closeDropdown() {
    timer = window.setTimeout(() => {
      this.isShowMenuDropdownUser = false
    }, 100)
  }

  private async logout() {
    await this.$auth.logout()
    if (process.client) {
      window.location.reload()
    }
  }

  private get colorType() {
    return {
      [this.$style.white]: this.white,
      [this.$style.default]: !this.white,
    }
  }
}
